export default __webpack_public_path__ + "3f162da87d6cd666bc5c00766868bfbf.webp";